<template>
    <div>
        <el-form class="w-review-info" label-width="120px">
            <el-form-item 
            v-for="(el,index) in list_info" 
            :key="'a_'+index" 
            :label="el.label">
                <span v-if="el.type=='html'" v-html="el.clfn(main_information)"></span>
                <span v-else>
                    {{el.clfn?el.clfn(main_information):main_information[el.prop]}}
                </span>
            </el-form-item>          
        </el-form>

        <div class="new_op_012" >
            <h3 class="new_op_012_1">审核流程</h3>

            <div v-for="(el,index) in check_detail" :key="'b_'+index">
                <div class="check_detail_01">
                    <div class="check_detail_02" :style="`background: ${clor[el.check_status]};`">{{type[el.check_status]}}</div>
                    <div class="check_detail_03">验收审核：{{el.check_admin_name}}</div>
                </div>
                <div v-if="el.check_status=='1'" class="check_detail_04">
                     <el-form  class="w-review-info" label-width="120px">
                         <el-form-item
                            v-for="(item,key) in el.check_info"
                            :key="key"
                            :label="key">
                            <div v-if="Array.isArray(item)">
                                <el-tag size="small" :key="tag" class="w-tag" type="info" effect="plain" v-for="tag in item">
                                    {{ tag }}
                                </el-tag>
                            </div>
                            <span v-else>
                                {{ item}}
                            </span>
                        </el-form-item>
                    </el-form>   
                    
                </div>

                <div v-if="el.check_status==-1" class="check_detail_04">
                    <el-form class="w-review-info" label-width="120px">
                         <el-form-item label="驳回理由">
                            {{ el.check_reason}}
                        </el-form-item>
                        <el-form-item label="驳回详情">
                            {{ el.check_comment}}
                        </el-form-item>
                    </el-form> 
                       
                </div>

                

            </div>
 
        </div>
    </div>
</template>
<script>

export default {
    props: {
        // 展示数据信息源
        datas: Object

    },
    computed:{
        main_information(){
            return this.datas.check_info?this.datas.check_info.main_information:{}
        },
        check_detail(){
            return this.datas.check_info?this.datas.check_info.check_detail:[]
        },
        
    },
    data() {
        return {
            clor:{
                '0':'#33B3FF',
                '1':'#27AE60',
                '-2':'#FF0000',
                '-1':'#FF0000',
            },
            type:{
                "0": "待审核",
                "1": "审核通过",
                "-1": "已驳回",
                "-2": "已失效或撤回",
                "-3": "已回退"
            },
            list_info:[
                {label:'审核ID',prop:'id'},
                {label:'提审项',clfn:()=>{
                    return '渠道分发'
                }},
                {label:'提审用户ID',prop:'open_id'},
                {label:'用户昵称',prop:'username'},
                {label:'提审时间',prop:'created_at'},
                {label:'审核状态',prop:'check_status',type:'html',clfn:da=>{
                    const ys = {
                        '0':'#33B3FF',
                        '1':'#27AE60',
                    };
                 
                    return `<span style="color:${ys[da.check_status] || '#FF0000'};">${this.type[da.check_status] || '未知'}</span>`
                }}
            ],
            info: {},
           

        };
    },
    methods: {
  
    },
 
 
   
};
</script>
<style lang="scss">
$prefixCls: 'w-examine-info';

.#{$prefixCls}{
    .w-review-info {
        padding: 0 40px;
        border-bottom: 1px solid #ddd;
    }

    $primary: #33B3FF;
    $success: #27AE60;
    $warning: #FF9200;
    $danger: #FF0000;
    $info: #979797;

    .w-examine-state {
        padding: 20px 40px 60px;
    }

    .w-state-wrap {
        margin-top: 20px;
        .w-content {
            background-color: #F6F6F6;
            height: 32px;
            line-height: 32px;
            display: inline-block;
            border: 1px solid #D8D8D8;
            padding: 0 20px;
            vertical-align: middle;
        }

        .w-label {
            padding: 0 10px;
            height: 32px;
            line-height: 32px;
            display: inline-block;
            text-align: center;
            color: white;
            vertical-align: middle;
            &.w-user-label {
                background-color: $warning;
                border: 1px solid $warning;
            }
            &.w-reject-label {
                background-color: $danger;
                border: 1px solid $danger;
            }
            &.w-pass-label {
                background-color: $success;
                border: 1px solid $success;
            }
            &.w-wait-label {
                background-color: $primary;
                border: 1px solid $primary;
            }
        }
    }

    .w-desc-wrap {
        border: 1px solid #D8D8D8;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        padding: 20px;
        .w-card-wrap {
            .p-card-item {
                margin-bottom: 20px;
                .p-examine-title {
                    margin-bottom: 20px;
                }

                .el-card__body {
                    border-radius: 4px;
                    min-height: 200px;
                    position: relative;
                }
                &.w-warning-border {
                    .el-card__body {
                        border: 1px solid $warning;
                    }
                }
                &.w-danger-border {
                    .el-card__body {
                        border: 1px solid $danger;   
                    }
                }
                &.w-success-border {
                    .el-card__body {
                        border: 1px solid $success;
                    }
                }
                .w-state-center {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                }
            }
        }
    }
    .el-form-item {
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 0;
        }
    }

    .w-tag {
        margin-right: 6px;
    }
}
.w-review-popover {
    .w-popover-content {
        .w-label {
            color: #333;
            margin: 10px 0;
        }
    }
}
.new_op_012{
    padding:60px 25px;
}
.new_op_012_1{
    border-bottom: 1px solid #D8D8D8;
    line-height: 40px;
    margin-bottom: 30px;
}
.check_detail_01{
    line-height: 32px;
    font-size: 12px;
}
.check_detail_02{
    display: inline-block;
    vertical-align: top;
    width: 104px;
    height: 32px;
    text-align: center;
    color: #fff;
}
.check_detail_03{
    display: inline-block;
    vertical-align: top;
    padding: 0 17px;
    background: #F6F6F6;
    border: 1px solid #D8D8D8;
    box-sizing: border-box;
    line-height: 30px;
}
.check_detail_04{
    width: 991px;
    box-sizing: border-box;
    border: 1px solid #D8D8D8;
    padding: 30px 52px;
}
</style>